<template>
  <v-dialog
    :model-value="store.isOpen"
    max-width="420"
    persistent
    @update:model-value="!$event && store.handleCancel()">
    <v-card>
      <v-card-title class="text-h6">{{ store.options.title }}</v-card-title>
      <v-card-text>{{ store.options.message }}</v-card-text>
      <v-card-actions class="justify-end">
        <v-btn variant="text" @click="store.handleCancel()">{{ store.options.cancelText }}</v-btn>
        <v-btn :color="store.options.confirmColor" variant="flat" @click="store.handleConfirm()">
          {{ store.options.confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { useConfirmDialogStore } from "@/stores";

const store = useConfirmDialogStore();
</script>
